/* import __COLOCATED_TEMPLATE__ from './task-suggestions-list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

interface Args {
  taskSuggestions: TaskSuggestion[];
  isLoading?: boolean;
  onShowConversationExplorer: (
    conversationIds: string[],
    actionName: string,
    actionSummary: string,
    conversationCount: number,
  ) => void;
}

interface Signature {
  Args: Args;
}

export default class TaskSuggestionsList extends Component<Signature> {
  get taskSuggestions() {
    let suggestions = this.args.taskSuggestions || [];
    return suggestions;
  }

  get hasTaskSuggestions() {
    let hasSuggestions = this.taskSuggestions.length > 0;
    return hasSuggestions;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions::TaskSuggestionsList': typeof TaskSuggestionsList;
    'reporting/automation/fin-ai-agent/analyze/task-suggestions/task-suggestions-list': typeof TaskSuggestionsList;
  }
}
